import React, { useState } from "react";
import "./SemiPlannedCosts.css";

const costTiersData = [
  { label: "기본 패키지", price: "100 ~ 250만 원", note: "총 제작비의 50%" },
  { label: "종이책 포함", price: "300 ~ 500만 원", note: "1,500부 기준" },
  { label: "프리미엄", price: "600만 원 ~", note: "고급 디자인, 마케팅 포함" },
];

const basicServicesData = [
  "ISBN 등록",
  "기본 편집",
  "표준 표지",
  "전자책 제작",
  "온라인 유통",
];
const additionalServicesData = [
  "전문 편집",
  "커스텀 디자인",
  "종이책 인쇄",
  "마케팅",
];
const monthlyManagementFeatures = [
  "진행사항 관리 : 출판 과정 실시간 모니터링",
  "판매 현황 확인 : 실시간 판매 데이터 조회",
  "인세 정산 : 자동 정산 및 세무 서류 제공",
  "커뮤니티 지원 : 저자 간 정보 교류 및 네트워킹",
  "저술 업무 지원 : 저술 참조 자료, 독자 소통 기능 등",
];

const costSharingData = {
  category: "비용 부담",
  self: "저자 100%",
  semi: "저자 50% + 출판사 50%",
  planned: "출판사 100%",
};

const columnDetails = {
  self: { label: "자비 출판", className: "cs-self" },
  semi: { label: "반기획 출판", className: "cs-semi" },
  planned: { label: "기획 출판", className: "cs-planned" },
};

const SemiPlannedCosts = () => {
  const [activeColumn, setActiveColumn] = useState("semi");

  return (
    <>
      <div className="publishing-costs-container">
        <h1 className="page-main-title">
          반기획 출판, 비용은 어떻게 책정될까요?
        </h1>
        <div className="costs-layout-grid">
          <div className="main-costs-card">
            <div className="main-costs-header">
              <h2>반기획 출판 저작자 부담분 기준</h2>
            </div>
            <div className="main-costs-body">
              <div className="tier-items-wrapper">
                {costTiersData.map((tier, index) => (
                  <div key={index} className="cost-tier-item">
                    <span className="tier-label">{tier.label}</span>
                    <p className="tier-price">{tier.price}</p>
                    <span className="tier-note">{tier.note}</span>
                  </div>
                ))}
              </div>
              <hr className="costs-divider" />
              <div className="services-section">
                <h3>기본 서비스</h3>
                <p>{basicServicesData.join(", ")}</p>
              </div>
              <hr className="costs-divider" />
              <div className="services-section">
                <h3>추가 서비스</h3>
                <p>{additionalServicesData.join(", ")}</p>
              </div>
            </div>
          </div>
          <div className="plus-symbol">+</div>
          <div className="side-card">
            <h3>저자 스튜디오</h3>
            <p className="side-card-intro">
              저자 스튜디오를 통해 아래 서비스를 지원 받을 수 있습니다.
            </p>
            <ul>
              {monthlyManagementFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="cost-sharing-section">
        <h2 className="cost-sharing-title">비용 분담 구조</h2>

        {/* DESKTOP TABLE */}
        <div className="cost-sharing-table-desktop">
          <div className="cs-header"></div>
          <div className="cs-header cs-self">자비 출판</div>
          <div className="cs-header cs-semi highlighted">반기획 출판</div>
          <div className="cs-header cs-planned">기획 출판</div>
          <div className="cs-cell cs-category">비용 부담</div>
          <div className="cs-cell">저자 100%</div>
          <div className="cs-cell highlighted">{costSharingData.semi}</div>
          <div className="cs-cell">출판사 100%</div>
        </div>

        {/* MOBILE/TABLET VIEW */}
        <div className="cost-sharing-table-mobile">
          <div className="cs-mobile-tabs">
            {Object.keys(columnDetails).map((key) => (
              <button
                key={key}
                onClick={() => setActiveColumn(key)}
                className={`cs-mobile-tab-button ${
                  columnDetails[key].className
                } ${activeColumn === key ? "active" : ""}`}
              >
                {columnDetails[key].label}
              </button>
            ))}
          </div>
          <div className="cs-mobile-content">
            <div className="cs-mobile-row">
              <div className="cs-mobile-cell cs-category">
                {costSharingData.category}
              </div>
              <div className="cs-mobile-cell cs-value-cell">
                {costSharingData[activeColumn]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SemiPlannedCosts;
